<template>
  <div>
    <div
      v-if="!datasReady"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <div
      v-else
      class="cloud-box"
    >
      <div class="tip-box">
        <a-alert
          v-if="status === 2"
          type="info"
          show-icon
        >
          <div slot="message">
            {{ cloudTipTxt[0] }}{{ time }}， {{ cloudTipTxt[1] }}：
            <p>1.{{ $t('message["319"]') }} </p>
            <p>2.{{ $t('message["1035"]') }} </p>
            <p>3.{{ $t('message["1034"]') }}IP</p>
          </div>
        </a-alert>
        <a-alert
          v-else-if="status === 1"
          type="success"
          show-icon
        >
          <div slot="message">
            {{ $t('message["1468"]') }}：{{ time }}
            <span class="edit-cloud-config">
              <a
                href="javascript:;"
                @click="editCloud"
              >{{ $t('message["1395"]') }}</a>
              <a
                href="javascript:;"
                @click="stopCloud"
              >{{ $t('message["1205"]') }}</a>
              <stop-cloud-dialog ref="StopCloudDialog" />
            </span>
          </div>
        </a-alert>
        <a-alert
          v-else-if="status === 0"
          type="warning"
          show-icon
        >
          <div slot="message">
            {{ $t('message["1475"]') }}：{{ time }}
          </div>
        </a-alert>
      </div>
      <div class="cloud-form">
        <a-form
          :form="form"
          :hide-required-mark="true"
          class="inquiry-detail"
          @submit.prevent="submitForm"
        >
          <a-form-item
            :label="`${orgTit}：`"
          >
            <a-input
              v-decorator="[
                'cid',
                {initialValue: $route.query.cid }
              ]"
              disabled
            />
          </a-form-item>
          <a-form-item
            label="Token："
          >
            <div class="token-box">
              <a-input
                v-decorator="[
                  'token',
                  {initialValue: tokennew }
                ]"
                :type="isShow?'text': 'password'"
                disabled
              />
              <i
                class="icon iconfont"
                :class="isShow ? 'iconicon-test85' : 'iconicon-test86' "
                @click="showHide"
              />
            </div>
            <template v-if="status === 2">
              <a-button
                id="copyBtn"
                class="ml-16"
                @click="doCopy"
              >
                {{ $t('message["318"]') }}
              </a-button>
              <a
                href="javascript:;"
                @click="getTokenId"
              >{{ $t('message["1623"]') }}</a>
            </template>
          </a-form-item>
          <a-form-item
            :label="`${domainTit}：`"
          >
            <a-input
              v-decorator="[
                'domain',
                {rules: [{ required: true, message: cloudDomainPlace }, {validator: validDomain}], initialValue: cloudDatas.domain }
              ]"
              :disabled="isDisabled"
              :placeholder="cloudDomainPlace"
            />
          </a-form-item>
          <a-form-item
            :label="`IP${whiteList}：`"
          >
            <a-input
              v-decorator="[
                'ip_list',
                {rules: [{ required: true, message: cloudDomainNeed },{validator: validIp}], initialValue:ipList }
              ]"
              :disabled="isDisabled"
              :placeholder="cloudIpPlace"
            />
          </a-form-item>
          <a-form-item v-if="!isDisabled">
            <a-button
              type="primary"
              html-type="submit"
            >
              {{ $t('message["1161"]') }}
            </a-button>
            <a-button @click="resetForm">
              {{ $t('message["896"]') }}
            </a-button>
          </a-form-item>
        </a-form>
        <tips-dialog ref="tipsDialog" />
      </div>
    </div>
  </div>
</template>
<script>
import VueClipboard from 'vue-clipboard2'
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import TipsDialog from '@/components/pc/organization/cloud/TipsDialog'
import StopCloudDialog from '@/components/pc/organization/cloud/StopCloudDialog'
Vue.use(VueClipboard)
export default {
  components: {
    TipsDialog,
    StopCloudDialog
  },
  data () {
    return {
      tokennew: '',
      isShow: false,
      isDisabled: false
    }
  },
  computed: {
    ...mapState('organization/cloud', ['datasReady', 'cloudDatas']),
    time () {
      const { cloudDatas } = this
      return `${cloudDatas.start_time} ～ ${cloudDatas.end_time}`
    },
    status () {
      const { cloudDatas } = this
      return cloudDatas.status
    },
    ipList () {
      const { cloudDatas } = this
      const len = cloudDatas.ip_list && cloudDatas.ip_list.length
      if (len >= 2) {
        return cloudDatas.ip_list.join(',')
      } else if (len === 1) {
        return cloudDatas.ip_list[0]
      } else {
        return ''
      }
    },
    whiteList () {
      return this.$t('message["10"]')
    },
    cloudTipTxt () {
      return this.$t('message["685"]').split('|')
    },
    cloudIpPlace () {
      return this.$t('message["806"]')
    },
    cloudDomainPlace () {
      return this.$t('message["808"]')
    },
    cloudDomainNeed () {
      return this.$t('message["807"]')
    },
    domainTit () {
      return this.$t('message["1522"]')
    },
    orgTit () {
      return this.$t('message["1675"]')
    }

  },
  created () {
    this.form = this.$form.createForm(this)
  },
  async mounted () {
    const chain = await this.fetchCloudDatas()
    chain.params({
      cid: this.$route.query.cid
    })
      .onSuccess(res => {
        this.tokennew = res.token
        this.isDisabled = (res.status === 1)
        // this.$refs.tipsDialog.changeLimitDialog(true)
      })
      .fetch()
  },
  methods: {
    ...mapActions('organization/cloud', ['fetchCloudDatas', 'getToken', 'saveCloud']),
    async getTokenId () {
      const chain = await this.getToken()
      chain.params({
        Authorization: this.$store.state.auth
      })
        .onSuccess(res => {
          this.tokennew = res.token
          this.form.setFieldsValue({ token: res.token })
        })
        .fetch()
    },
    doCopy () {
      const that = this
      this.$copyText(this.tokennew).then(function (e) {
        // alert('复制成功')
        that.$message.success(that.$t('message["321"]'))
      }, function (e) {
        that.$message.error(that.$t('message["324"]'))
      })
    },
    showHide () {
      this.isShow = !this.isShow
    },
    resetForm () {
      this.form.resetFields()
    },
    editCloud () {
      this.isDisabled = false
    },
    stopCloud () {
      this.$refs.StopCloudDialog.changeVisible(true)
    },
    submitForm () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const obj = Object.assign(values, { cid: this.$route.query.cid * 1 })
          const chain = await this.saveCloud()
          chain.params(obj)
            .onSuccess(res => {
              this.$refs.tipsDialog.changeLimitDialog(true)
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    validDomain (rule, value, callback) {
      const domain = window.location.hostname
      const res = domain.indexOf('dev') > -1 ? /^((http):\/\/)([\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?)?$/ : /^((https):\/\/)([\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?)?$/
      if (!res.test(value)) {
        callback(new Error(this.$t('message["835"]')))
      } else {
        callback()
      }
    },
    validIp (rule, value, callback) {
      const res = /((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))/
      if (!res.test(value)) {
        callback(new Error(this.$t('message["833"]')))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .cloud-box::v-deep {
    .tip-box {
      margin: 24px 0  24px;
    }
    .tip-box p{
      line-height: 24px;
    }
    .token-box {
      display: inline-block;
      position: relative;
      .ant-input{
        padding-right: 36px;
      }
      i{
        position: absolute;
        right: 12px;
        color: #999;
        top: 2px;
      }
    }
    .edit-cloud-config {
      a {
        margin-left: 16px;
      }
    }
  }
</style>
